<template>
  <div class="base-tag" :class="{ removable }">
    <slot />
    <XIcon v-if="removable" data-jest="x-icon" size="1x" />
  </div>
</template>

<script setup lang="ts">
import { XIcon } from '~/components/veke-ui/icons'

defineProps({
  removable: {
    type: Boolean,
    required: false,
    default: false
  }
})
</script>

<style lang="scss">
.base-tag {
  @apply py-[.25em] px-[1em] w-fit bg-black text-white rounded-full;
  @apply inline-flex gap-2 items-center whitespace-nowrap;
  &.removable {
    @apply cursor-pointer;
  }
}
</style>
